export default __webpack_public_path__ + "static/media/25.8220b166.jpg";